import { Link } from "react-router-dom";
import { telLink, waLink } from "../data/products";
import { useLang } from "../i18n";
import { Micro, useHashNav } from "./Reveal";

const MENU = [
  { key: "about", hash: "#about" },
  { key: "services", hash: "#services" },
  { key: "products", hash: "#products" },
  { key: "projects", hash: "#projects" },
  { key: "journal", hash: "#journal" },
  { key: "contact", hash: "#contact" },
];

export default function Footer() {
  const go = useHashNav();
  const { t } = useLang();
  const serviceList = t("footer.serviceList");

  return (
    <footer data-testid="footer" className="border-t border-white/10 px-5 md:px-12 pt-16 pb-8">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <Link to="/" data-testid="footer-logo" data-cursor="link">
            <img src="/logo.png" alt="INT–EXT" className="w-40 md:w-48 mix-blend-screen" />
          </Link>
          <p className="text-sm text-cream/45 leading-relaxed mt-6 max-w-xs">
            {t("footer.about")}
          </p>
        </div>

        <div className="md:col-span-3">
          <Micro className="block mb-5">{t("footer.servicesTitle")}</Micro>
          <div className="space-y-2.5">
            {serviceList.map((s) => (
              <div key={s} className="text-sm text-cream/55">{s}</div>
            ))}
          </div>
        </div>

        <div className="md:col-span-2">
          <Micro className="block mb-5">{t("footer.quickLinks")}</Micro>
          <div className="space-y-3">
            {MENU.map((m) => (
              <button
                key={m.key}
                data-testid={`footer-link-${m.key}`}
                data-cursor="link"
                onClick={() => go(m.hash)}
                className="block text-sm text-cream/60 hover:text-gold transition-colors uppercase tracking-[0.15em]"
              >
                {t(`nav.${m.key}`)}
              </button>
            ))}
            <Link
              to="/catalogue"
              data-testid="footer-link-catalogue"
              data-cursor="link"
              className="block text-sm text-cream/60 hover:text-gold transition-colors uppercase tracking-[0.15em]"
            >
              {t("nav.catalogue")}
            </Link>
          </div>
        </div>

        <div className="md:col-span-3">
          <Micro className="block mb-5">{t("footer.contactTitle")}</Micro>
          <a
            href={telLink}
            data-testid="footer-phone"
            data-cursor="link"
            className="block text-sm text-cream/70 hover:text-gold transition-colors uppercase tracking-[0.15em]"
          >
            {t("contact.call")}
          </a>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp"
            data-cursor="link"
            className="block text-sm text-cream/70 hover:text-gold transition-colors uppercase tracking-[0.15em] mt-3"
          >
            {t("contact.whatsapp")}
          </a>
          <Micro className="block mt-5">{t("footer.location")}</Micro>
        </div>
      </div>

      <div className="mt-16 pt-6 border-t border-white/5 flex flex-wrap justify-between gap-3">
        <Micro>{t("footer.rights")}</Micro>
        <Micro>{t("footer.brand")}</Micro>
      </div>
    </footer>
  );
}
